import style from "./Loader.css";

const Loader = () => {
  return (
    <div class={style.view}>
      <div class={style.loaderBallz}>
        <div class={style.childOne}></div>
        <div class={style.childTwo}></div>
        <div class={style.childThree}></div>
      </div>
    </div>
  );
};

export { Loader };
